import { EventFormQuestion } from "@ac-expo/api-types";
import { Control } from "react-hook-form";
import { CreateEventFormAnswersForm } from "@ac-expo/api";
import { FormSelect } from "../form/FormSelect";
import { Label } from "../Label";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "../Select";

interface EventFormListProps {
  question: EventFormQuestion;
  control?: Control<CreateEventFormAnswersForm>;
  index?: number;
  isReadOnly?: boolean;
}

export default function EventFormList({
  question,
  control,
  index,
  isReadOnly = false,
}: EventFormListProps) {
  if (isReadOnly) {
    return (
      <div className="space-y-2">
        <Label className="text-sm text-gray-600">
          {question.theme} : {question.question}
        </Label>
        <Select>
          <SelectTrigger className="bg-gray-50">
            <SelectValue placeholder="Sélectionnez une option..." />
          </SelectTrigger>
          <SelectContent>
            {question.options.map((option) => (
              <SelectItem key={option.label} value={option.label}>
                <span className="truncate break-words">{option.label}</span>
              </SelectItem>
            ))}
          </SelectContent>
        </Select>
      </div>
    );
  }

  if (!control || index === undefined) {
    throw new Error(
      "control and index are required when not in read-only mode"
    );
  }

  return (
    <FormSelect
      key={question.id}
      control={control}
      name={`answers.${index}.answer`}
      label={`${question.theme} : ${question.question}`}
      placeholder="Sélectionnez une option..."
      items={question.options.map((option) => ({
        label: (
          <span className="max-w-xs truncate break-words">{option.label}</span>
        ),
        value: option.label,
      }))}
      hasMessage
    />
  );
}
